(function () {
  if (window.__hlInit) return;
  window.__hlInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function getObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        if (el.classList.contains('hl-reveal')) el.classList.add('hl-visible');
        if (el.hasAttribute('data-hl-huellas')) setTimeout(function () { el.classList.add('is-limpio'); }, 1600);
        if (el.hasAttribute('data-hl-ciclo')) arrancarCiclo(el);
        observer.unobserve(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    return observer;
  }

  function initReveals(root) {
    var io = getObserver();
    root.querySelectorAll('.hl-reveal, [data-hl-huellas], [data-hl-ciclo]').forEach(function (el) {
      if (el.dataset.hlObs) return;
      el.dataset.hlObs = '1';
      if (!io || reduce) {
        el.classList.add('hl-visible');
        if (el.hasAttribute('data-hl-huellas')) el.classList.add('is-limpio');
        if (el.hasAttribute('data-hl-ciclo')) marcarPaso(el, 0);
        return;
      }
      io.observe(el);
    });
  }

  /* Tira de cuidado: Agua → Gira → Seca en 10 segundos */
  function marcarPaso(tira, i) {
    tira.querySelectorAll('.hl-ciclo-tira__paso').forEach(function (p, n) { p.classList.toggle('is-activo', n === i); });
  }
  function arrancarCiclo(tira) {
    if (tira.dataset.hlRun) return;
    tira.dataset.hlRun = '1';
    var pasos = tira.querySelectorAll('.hl-ciclo-tira__paso').length || 3;
    var inicio = performance.now();
    tira.classList.add('is-corriendo');
    function tick(t) {
      if (!document.body.contains(tira)) return;
      var fase = ((t - inicio) % 10000) / 10000;
      marcarPaso(tira, Math.min(pasos - 1, Math.floor(fase * pasos)));
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* Selector de tallas */
  function initTallas(root) {
    root.querySelectorAll('[data-hl-tallas]').forEach(function (box) {
      if (box.dataset.hlInit) return;
      box.dataset.hlInit = '1';
      var botones = box.querySelectorAll('[data-talla]');
      var fichas = box.querySelectorAll('[data-ficha]');
      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          botones.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          fichas.forEach(function (f) { f.hidden = f.dataset.ficha !== b.dataset.talla; });
        });
      });
    });
  }

  /* Formularios de compra con variantes (chips) */
  function initCompras(root) {
    root.querySelectorAll('[data-hl-compra]').forEach(function (form) {
      if (form.dataset.hlInit) return;
      form.dataset.hlInit = '1';
      var datos = form.querySelector('script[data-hl-variantes]');
      var variantes = datos ? JSON.parse(datos.textContent) : [];
      var scope = form.closest('[data-hl-scope]') || form;
      var input = form.querySelector('input[name="id"]');
      var boton = form.querySelector('[data-hl-boton]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';

      function actual() {
        var sel = [];
        form.querySelectorAll('fieldset[data-indice]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          sel[+fs.dataset.indice] = c ? c.value : null;
          var leyenda = fs.querySelector('[data-valor]');
          if (leyenda && c) leyenda.textContent = c.value;
        });
        return variantes.find(function (v) { return v.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); });
      }
      function pintar(ev) {
        var v = actual();
        if (!v) return;
        input.value = v.id;
        scope.querySelectorAll('[data-hl-precio]').forEach(function (n) { n.textContent = v.price; });
        scope.querySelectorAll('[data-hl-compare]').forEach(function (n) { n.textContent = v.compare || ''; n.hidden = !v.compare; });
        scope.querySelectorAll('[data-hl-ahorro]').forEach(function (n) { n.hidden = !v.save; if (v.save) n.textContent = n.dataset.plantilla.replace('[ahorro]', v.save); });
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.media && ev) {
          var visor = scope.querySelector('[data-hl-visor]');
          if (visor) mostrarMedia(visor, v.media);
        }
      }
      form.addEventListener('change', pintar);

      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return;
        ev.preventDefault();
        var msg = form.querySelector('[data-hl-msg]');
        boton.classList.add('is-loading');
        var body = new FormData(form);
        var drawer = document.querySelector('cart-drawer');
        var secciones = drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';
        body.append('sections', secciones);
        body.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            boton.classList.remove('is-loading');
            if (res.status) {
              if (msg) { msg.textContent = res.description || res.message; msg.classList.add('is-error'); }
              return;
            }
            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { form.submit(); });
      });
      pintar();
    });
  }

  /* Galería de la página de producto */
  function mostrarMedia(visor, id) {
    var img = visor.querySelector('img');
    var mini = document.querySelector('[data-hl-mini="' + id + '"]');
    if (!img || !mini) return;
    var video = visor.querySelector('video');
    if (video) video.remove();
    img.hidden = false;
    if (mini.dataset.video) {
      video = document.createElement('video');
      video.src = mini.dataset.video;
      video.poster = mini.dataset.grande;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = true;
      video.autoplay = !reduce;
      video.setAttribute('aria-label', mini.dataset.alt || '');
      img.hidden = true;
      visor.appendChild(video);
      if (!reduce) video.play().catch(function () {});
    }
    img.src = mini.dataset.grande;
    img.srcset = '';
    img.alt = mini.dataset.alt || '';
    document.querySelectorAll('[data-hl-mini]').forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
  }
  function initGaleria(root) {
    root.querySelectorAll('[data-hl-mini]').forEach(function (m) {
      if (m.dataset.hlInit) return;
      m.dataset.hlInit = '1';
      m.addEventListener('click', function () {
        var visor = m.closest('[data-hl-scope]').querySelector('[data-hl-visor]');
        mostrarMedia(visor, m.dataset.hlMini);
      });
    });
  }

  /* Barra fija de compra en móvil */
  function initBarra(root) {
    var barra = root.querySelector('[data-hl-barra]');
    var objetivo = root.querySelector('[data-hl-boton]');
    if (!barra || !objetivo || barra.dataset.hlInit || !('IntersectionObserver' in window)) return;
    barra.dataset.hlInit = '1';
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('is-visible', pasado);
      });
    }).observe(objetivo);
    var pend = false;
    window.addEventListener('scroll', function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; barra.classList.toggle('is-visible', objetivo.getBoundingClientRect().bottom < 0); });
    }, { passive: true });
    barra.querySelector('button').addEventListener('click', function () {
      objetivo.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    });
  }

  function initTodo(e) {
    var root = (e && e.target && e.target.querySelectorAll) ? e.target : document;
    initReveals(root);
    initTallas(root);
    initCompras(root);
    initGaleria(root);
    initBarra(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
